import { render } from "./AddTask.vue?vue&type=template&id=28ac8e50&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=28ac8e50&scoped=true&lang=css"

import exportComponent from "/Users/alexkval/src/vue/vue-crash-2022/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ac8e50"]])

export default __exports__